<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" :title="baseForm.wareHouseId ? (isEdit ? '编辑仓库' : '查看仓库') : '新增仓库'"
    v-bind="$attrs" v-on="$listeners">
    <div class="edit-box flex-c-e" v-show="baseForm.wareHouseId">
      <el-button v-if="mixinHasPermi(['wareHouse:update'])" type="primary" class="edit" @click="toggleEdit">{{
        isEdit ? "取消编辑" : "编辑"
      }}</el-button>
    </div>
    <div class="el-dialog-body-child" v-closeSelect>
      <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules"
        :disabled="!!(!isEdit && baseForm.wareHouseId)" label-width="120px">
        <el-form-item class="half" label="父级仓库" key="parentWareHouseId" prop="parentWareHouseId">
          <el-cascader aria-hidden="false" disabled :options="wareHouseData" :props="props"
            v-model="dialogForm.parentWareHouseId" clearable placeholder="请选择父级仓库" />
        </el-form-item>
        <el-form-item class="half" label="仓库名称" key="wareHouseName" prop="wareHouseName">
          <el-input v-model.trim="dialogForm.wareHouseName" clearable :placeholder="`请输入仓库名称`" />
        </el-form-item>
        <el-form-item class="half" label="仓库容量" key="maxQuantity" prop="maxQuantity">
          <el-input v-model.trim="dialogForm.maxQuantity"  @input="handleInput('maxQuantity')" @blur="handleBlur('maxQuantity')" clearable :placeholder="`请输入仓库容量`" />
        </el-form-item>
        <el-form-item class="half"  label="已用数量" key="quantity" prop="quantity">
          <el-input v-model.trim="dialogForm.quantity" disabled></el-input>
        </el-form-item>
        <el-form-item v-if="baseForm.wareHouseId" class="half" label="使用率" key="quantity" prop="quantity">
          {{((dialogForm.quantity / dialogForm.maxQuantity) * 100).toFixed(2)}}%
        </el-form-item>
        <el-form-item v-if="!!(!isEdit && baseForm.wareHouseId)" class="half" label="仓库状态" key="capacityStatus" prop="capacityStatus">
          <el-tag-dict dictType="CAPACITY_STATUS" :value="dialogForm.capacityStatus"></el-tag-dict>
        </el-form-item>

        <el-form-item class="all" label="备注" key="remark" prop="remark">
          <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
            placeholder="请输入备注" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          !baseForm.wareHouseId || isEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button type="primary" @click="submitForm" v-show="!baseForm.wareHouseId || isEdit">确 定</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import { wareHouseApi } from "@/api"
export default {
  name: "WareHouseDialog",
  props: {
    // 仓库数据
    wareHouseData: {
      type: Array,
      default: () => {
        return []
      }
    },
    props: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 是否是编辑
    isUpdate: {
      type: Boolean,
      default: false
    },
    // 配置数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    /** 检查仓库名称是否已存在 */
    const checkWareHouseName = (rule, value, callback) => {
      wareHouseApi
        .judgeWareHouseNameExist({parentWareHouseId: this.dialogForm.parentWareHouseId, wareHouseName: value, wareHouseId: this.dialogForm.wareHouseId })
        .then((data) => {
          if (data.validateResult) {
            callback()
          } else {
            callback(data.msg)
          }
        })
    }

    return {
      isEdit: false, // 是否是在编辑
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {
        parentWareHouseId: [
          { required: true, message: "请选择父级仓库", trigger: "change" }
        ],
        wareHouseName: [
          { required: true, message: "请输入仓库名称", trigger: ["blur"] },
          { validator: checkWareHouseName, trigger: ["blur"] }
        ],
        maxQuantity: [{ required: true, message: "请输入仓库容量", trigger: "blur" }]
      }
    }
  },
  watch: {
    isUpdate(val) {
      this.isEdit = val
    },
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.renderPageData(val)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleBlur(key) {
      const str = this.dialogForm[key]
      // 特殊情况处理：空字符串或单个0
      if (str === "0" || str === "") {
        this.dialogForm[key] = ""
        return
      }
      // 去除开头的0
      const result = str.replace(/^0+/, "")
      // 如果去除后变成空字符串，说明原字符串全是0，返回单个0
      if (result === "") {
        this.dialogForm[key] = ""
        return
      }
      this.dialogForm[key] = result
    },
    handleInput(key) {
      this.dialogForm[key] = this.dialogForm[key].replace(/[^\d]/g, "")
    },
    // 重新渲染页面数据
    renderPageData(val) {
      this.dialogForm = JSON.parse(JSON.stringify(val))
    },
    // 编辑或取消编辑
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.isEdit = false
      this.renderPageData(this.baseForm)
    },
    // 重置表单
    resetForm() {
      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["dialogFormRef"].validate(async(valid) => {
        if (valid) {
          //更新
          if (this.dialogForm.wareHouseId) {
            wareHouseApi.updateItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("编辑仓库成功")
              this.$emit("close")
              this.$emit("successs")
            })
          } else {
            //新增
            wareHouseApi.createItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("新增仓库成功")
              this.$emit("close")
              this.$emit("successs")
            })
          }
        }
      })
    }
  }
}
</script>
